// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HP3_","comment":"styles_comment__1oDLR"};